module.exports = __webpack_public_path__ + "static/img/page10-bg.be370dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page10-bg.png
// module id = VSqo
// module chunks = 215